module.exports = __webpack_public_path__ + "img/restaurant-marker.5c4f5026.svg";